import React from 'react';
import Table from './Table';
import Pager from './Pager';
import { takePage } from '../utils/core';

const PagedTable = ({ columns, items, pageSize, page, onPageClick, className, isLoading, keyGenerator }) => (
    <>
        <Table 
            className={className} 
            columns={columns}
            items={takePage(pageSize, page, items)}
            isLoading={isLoading}
            keyGenerator={keyGenerator}
        />
        <Pager page={page} pageSize={pageSize} total={items.length} onPageClick={onPageClick} />
    </>
);

export default PagedTable;
